export const reportees = [
  {
    id: 1,
    name: "Lilly Williams",
    shift: "General",
    shiftTime: "9:00 AM - 6:00 PM",
    weekend: true,
    image: "https://randomuser.me/api/portraits/women/1.jpg",
    status: "Present",
    hours: "8:30",
  },
  {
    id: 2,
    name: "Clarkson Walter",
    shift: "General",
    shiftTime: "9:00 AM - 6:00 PM",
    weekend: true,
    image: "https://randomuser.me/api/portraits/men/2.jpg",
    status: "Late",
    hours: "7:45",
  },
  {
    id: 3,
    name: "Sophia Johnson",
    shift: "General",
    shiftTime: "9:00 AM - 6:00 PM",
    weekend: true,
    image: "https://randomuser.me/api/portraits/women/3.jpg",
    status: "Present",
    hours: "8:15",
  },
  {
    id: 4,
    name: "Michael Brown",
    shift: "Night",
    shiftTime: "10:00 PM - 6:00 AM",
    weekend: false,
    image: "https://randomuser.me/api/portraits/men/4.jpg",
    status: "On Leave",
    hours: "0:00",
  },
  {
    id: 5,
    name: "Emma Wilson",
    shift: "General",
    shiftTime: "9:00 AM - 6:00 PM",
    weekend: true,
    image: "https://randomuser.me/api/portraits/women/5.jpg",
    status: "Present",
    hours: "9:00",
  },
  {
    id: 6,
    name: "James Taylor",
    shift: "Evening",
    shiftTime: "12:00 PM - 9:00 PM",
    weekend: false,
    image: "https://randomuser.me/api/portraits/men/6.jpg",
    status: "Half Day",
    hours: "4:30",
  },
  {
    id: 7,
    name: "Olivia Davis",
    shift: "General",
    shiftTime: "9:00 AM - 6:00 PM",
    weekend: true,
    image: "https://randomuser.me/api/portraits/women/7.jpg",
    status: "Present",
    hours: "8:45",
  },
  {
    id: 8,
    name: "William Miller",
    shift: "Morning",
    shiftTime: "6:00 AM - 3:00 PM",
    weekend: false,
    image: "https://randomuser.me/api/portraits/men/8.jpg",
    status: "Absent",
    hours: "0:00",
  },
];

export const currentUser = {
  id: 99,
  name: "You",
  shift: "General",
  shiftTime: "9:00 AM - 6:00 PM",
  image: "https://randomuser.me/api/portraits/lego/1.jpg",
};

export const pad = (n) => String(n).padStart(2, "0");
export const fmtTime = (d = new Date()) =>
  d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true });
export const dateKey = (d) => d.toISOString().split("T")[0];

export function parseTimeToMinutes(ts) {
  if (!ts) return null;
  const m = ts.trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (!m) return null;
  let hh = parseInt(m[1], 10);
  const mm = parseInt(m[2], 10);
  const ap = m[3].toUpperCase();
  if (ap === "PM" && hh < 12) hh += 12;
  if (ap === "AM" && hh === 12) hh = 0;
  return hh * 60 + mm;
}

export const START_MIN = 9 * 60;
export const END_MIN = 18 * 60;

export const minsToPct = (m) => {
  if (m < START_MIN) return 0;
  if (m > END_MIN) return 100;
  return ((m - START_MIN) / (END_MIN - START_MIN)) * 100;
};

export const timeStrToPct = (ts) => {
  const m = parseTimeToMinutes(ts);
  if (m == null) return null;
  return minsToPct(m);
};

export const nowPct = () => {
  const d = new Date();
  return minsToPct(d.getHours() * 60 + d.getMinutes());
};